import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  IconButton,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { useDialog } from "helper/customHook";
import { DIALOG } from "helper/enum/dialogEnum";
import { isOpenDialogSelector } from "redux-store/static/redux/selector";
import { useDispatch, useSelector } from "react-redux";
import pxToRem from "theme/base/pxToRem";
import {
  DialogTitleCustom,
  Title,
} from "modules/PersonnelInformation/Pages/Main/component/modal/style";
import { ReactComponent as IconClose } from "assets/svg/20-close.svg";
import {
  sendFeedbackDataSelector,
  sendFeedbackStatusSelector,
} from "modules/DeclareLeave/redux/selector";
import { ApproveStatusValue } from "../../const";
import { SCREEN } from "helper/roleChecker/Screens";

import { TYPE_LEAVE } from "modules/DeclareLeave/redux/getReasonLeave";
import {
  handleResetDataFeedback,
  handleSendFeedbackStart,
  setupFeedback,
} from "modules/DeclareLeave/redux/sendFeedback";
import AutoResizeTextarea from "components/common/AutoResizeTextarea";
import { useParams } from "react-router-dom";

const optionTypeLeave = {
  [TYPE_LEAVE.HALF_DAY]: {
    label: "Đi làm nửa ngày",
    value: TYPE_LEAVE.HALF_DAY,
  },
  [TYPE_LEAVE.FULL_DAY]: {
    label: "Đi làm cả ngày",
    value: TYPE_LEAVE.FULL_DAY,
  },
};

const SendFeedback = () => {
  const dispatch = useDispatch();
  const { tab } = useParams();
  const sendFeedbackDialog = useDialog(DIALOG.SEND_FEEDBACK);

  const open = useSelector(isOpenDialogSelector(DIALOG.SEND_FEEDBACK));

  const data = useSelector(sendFeedbackDataSelector);
  const status = useSelector(sendFeedbackStatusSelector);

  const handleSubmit = () => {
    dispatch(
      handleSendFeedbackStart(
        tab === "time-keeping" ? SCREEN.IP_015 : SCREEN.IP_017
      )
    );
    handleClose();
  };

  const handleClose = () => {
    dispatch(handleResetDataFeedback());
    sendFeedbackDialog.close();
  };

  const handleChangeType = (type: string) => {
    dispatch(setupFeedback({ type }));
  };
  const handleChangeReason = (reason: string) => {
    dispatch(setupFeedback({ reason }));
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitleCustom>
        <Title>
          {data.id ? "Chỉnh sửa đơn " : "Gửi "} phản hồi - Ngày {data.date}
        </Title>
        <IconButton onClick={handleClose}>
          <IconClose />
        </IconButton>
      </DialogTitleCustom>

      <>
        <DialogContent
          sx={(theme) => ({
            p: 0,
          })}
        >
          <Box
            sx={(theme) => ({
              margin: 2,
              mt: 0,
              mb: 0,
              paddingBottom: 1,
              background: "white",
              borderRadius: pxToRem(8),
            })}
          >
            <Typography fontSize={14}>Chọn loại gửi phản hồi</Typography>
            <FormControl
              component="fieldset"
              fullWidth
              sx={{ mt: pxToRem(12), mb: pxToRem(20) }}
            >
              <RadioGroup
                row
                value={data.type}
                onChange={(option) => handleChangeType(option.target.value)}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: pxToRem(8),
                }}
              >
                {Object.values(optionTypeLeave).map((duration) => (
                  <FormControlLabel
                    key={duration.value}
                    value={duration.value}
                    control={<Radio />}
                    label={duration.label}
                    sx={(theme) => ({
                      border: `1px solid `,
                      ".Mui-checked": {
                        color: `${theme.palette.stroke.strokeBrand} !important`, // Label color when checked
                      },

                      borderRadius: pxToRem(4),
                      margin: 0,
                      span: {
                        fontSize: pxToRem(14),
                      },
                      borderColor:
                        data.type === duration.value
                          ? theme.palette.stroke.strokeBrand
                          : `${theme.palette.stroke.strokeDefault}`,
                    })}
                    disabled={
                      data.explainAllow === TYPE_LEAVE.HALF_DAY &&
                      duration.value === TYPE_LEAVE.FULL_DAY
                    }
                  />
                ))}
              </RadioGroup>
            </FormControl>
            <Box display={"flex"} gap={0.5}>
              <Typography fontSize={14}>Giải trình lý do </Typography>
              <Typography
                fontSize={14}
                sx={(theme) => ({ color: theme.palette.text.textSecondary })}
              >
                {`(bắt buộc)`}
              </Typography>
            </Box>
            <AutoResizeTextarea
              placeholder="Nhập giải trình của bạn"
              onChange={handleChangeReason}
              sx={{ width: "100%", paddingTop: 1, paddingBottom: 1 }}
              value={data.reason}
            />
          </Box>
          <Box
            margin={2}
            my={0}
            sx={(theme) => ({
              lineHeight: pxToRem(20),
              ul: {
                paddingLeft: 4,
                listStyleType: "disc",
                fontSize: theme.typography.size.sm_14,
                fontWeight: theme.typography.fw_regular_400,
                color: theme.palette.text.textSecondary,
              },
            })}
          >
            <Typography
              sx={(theme) => ({
                fontSize: theme.typography.size.sm_14,
                fontWeight: theme.typography.fw_regular_400,
                color: theme.palette.text.textPrimary,
              })}
            >
              Trường hợp CBNV đi làm nhưng quên chấm công, cụ thể:
            </Typography>
            <Typography
              sx={(theme) => ({
                fontSize: theme.typography.size.sm_14,
                fontWeight: theme.typography.fw_regular_400,
                color: theme.palette.text.textPrimary,
              })}
            >
              - <b>Quên chấm công từ 1 – 3 ngày làm việc:</b> CBNV thực hiện vào
              hệ thống Iportal khai báo quên chấm công và phải được CBQL xác
              nhận.
            </Typography>
            <Typography
              sx={(theme) => ({
                fontSize: theme.typography.size.sm_14,
                fontWeight: theme.typography.fw_regular_400,
                color: theme.palette.text.textPrimary,
              })}
            >
              - <b>Quên chấm công từ ngày thứ 4 trở đi:</b>
            </Typography>
            <Typography
              sx={(theme) => ({
                fontSize: theme.typography.size.sm_14,
                fontWeight: theme.typography.fw_regular_400,
                color: theme.palette.text.textPrimary,
                paddingLeft: 2,
              })}
            >
              + Đối tượng chấm công 1 lần/ngày: Chuyển thành nghỉ bù/nghỉ
              phép/không lương. <br />+ Đối tượng chấm công 2 lần/ngày:
            </Typography>
            <ul style={{ paddingLeft: 50 }}>
              <li>
                Quên chấm cả 2 lần/ngày: Chuyển thành nghỉ bù/nghỉ phép/không
                lương
              </li>
              <li>
                Quên chấm 1 lần/ngày: sẽ được tính nửa ngày đi làm, nửa ngày
                chuyển thành nghỉ bù/nghỉ phép/không lương
              </li>
            </ul>
          </Box>
        </DialogContent>

        {/* Actions */}
        <DialogActions
          sx={{ justifyContent: "space-between", px: 3, pb: 2, pt: 2 }}
        >
          <Box display="flex" width={"100%"}>
            <Button
              variant="blur"
              onClick={handleClose}
              fullWidth
              sx={(theme) => ({
                mr: 1,
                background: theme.palette.background.bgSecondary,
                color: theme.palette.text.textPrimary,
              })}
            >
              Hủy bỏ
            </Button>

            <Button
              color="primary"
              fullWidth
              sx={{ mr: 1, gap: 1 }}
              disabled={
                !data.type ||
                !(data.reason ?? "").trim() ||
                status === ApproveStatusValue.PENDING
              }
              onClick={handleSubmit}
            >
              {data.id ? "Xác nhận thay đổi" : "Gửi phản hồi"}
            </Button>
          </Box>
        </DialogActions>
      </>
    </Dialog>
  );
};

export default SendFeedback;
